export interface CommitteeHistoryHighlightTarget {
  committeeName: string;
  position: string | null | undefined;
  startDate: string | null | undefined;
  endDate: string | null | undefined;
}

export function committeeHistoryHighlightId({
  committeeName,
  position,
  startDate,
  endDate
}: CommitteeHistoryHighlightTarget) {
  return [committeeName, position ?? "", startDate ?? "", endDate ?? ""].join("|");
}
